import { formatCurrency, formatPercent } from '../lib/formatCurrency.js';

const statusStyles = {
  Loss: 'border-rose-200 bg-rose-50 text-rose-700',
  Thin: 'border-amber-200 bg-amber-50 text-amber-700',
  Safe: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  Good: 'border-cyan-200 bg-cyan-50 text-cyan-700',
};

function Metric({ label, value, tone = 'default' }) {
  const valueClass = tone === 'danger' ? 'text-rose-700' : tone === 'good' ? 'text-emerald-700' : 'text-slate-950';

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <p className="text-sm font-medium text-slate-500">{label}</p>
      <p className={`mt-2 text-2xl font-bold tracking-normal ${valueClass}`}>{value}</p>
    </div>
  );
}

export default function ResultCard({ result }) {
  const profitTone = result.netProfit < 0 ? 'danger' : result.profitStatus === 'Good' ? 'good' : 'default';

  return (
    <section className="panel-card p-5 sm:p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h2 className="text-xl font-semibold tracking-normal text-slate-950">Ringkasan Hasil</h2>
          <p className="mt-1 text-sm text-slate-500">
            {result.marketplaceLabel} · {result.categoryLabel} · Qty {result.quantity}
          </p>
        </div>
        <span
          className={`inline-flex w-fit rounded-full border px-3 py-1 text-sm font-semibold ${
            statusStyles[result.profitStatus] || statusStyles.Thin
          }`}
        >
          {result.profitStatus}
        </span>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <Metric label="Net Profit" value={formatCurrency(result.netProfit)} tone={profitTone} />
        <Metric label="Margin" value={formatPercent(result.marginPercentage)} />
        <Metric label="Net Payout" value={formatCurrency(result.netPayout)} />
        <Metric label="Harga Aman / Unit" value={formatCurrency(result.safeSellingPrice)} tone="good" />
      </div>
    </section>
  );
}
